export const elasticPrimaryConfig = {
  host: window.aqSkillOptions?.insightsElasticHost || '',
  apiKey: window.aqSkillOptions?.insightsElasticAPIKey || '',
  index: window.aqSkillOptions?.insightsElasticJobIndex || '',
};
